import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbOffcanvas, NgbOffcanvasRef, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { DateInputFillMode, DateInputRounded, DateInputSize } from '@progress/kendo-angular-dateinputs';
import { Subscription } from 'rxjs';
import { ROUTES } from 'src/app/core/constants/routes-constants';
import { StartupService } from 'src/app/core/services/startup.service';
import { PopupComponent } from 'src/app/extensions/components/popup/popup.component';
import { USER_NAV_ACTIONS } from 'src/app/extensions/constants/commonConstants';
import { RESPONSIVE_BREAKPOINTS } from 'src/app/extensions/constants/responsive-breakpoints';
import { NotificationAPIService } from 'src/app/extensions/services/api/notification-api.service';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { WindowEventsService } from 'src/app/extensions/services/window-events.services';

@Component({
  selector: 'header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
  standalone: false,
})
export class HeaderMenuComponent implements OnInit, OnDestroy {
  @Input() menuItems: app.models.SidebarMenuItems[] = [];
  @Input() isAdmin: boolean;
  @Input() username: string;
  @Input() showAppVersion: boolean;

  @Input() hasUserRights: boolean = false;
  @Output() userNavOptionSelect = new EventEmitter<string>();

  @ViewChild('notificationsPopOver') notificationsPopOver: NgbPopover;

  public fillModeOutline: DateInputFillMode = 'outline';
  public roundedLarge: DateInputRounded = 'large';
  public sizeLarge: DateInputSize = 'large';

  public ngbOffcanvas: NgbOffcanvasRef;
  public ngbOffcanvasClosedResult: string | undefined = undefined;

  public numberOfNotifications: number;
  public maxVisibleNumberOfNotifications: number = 99;
  public subscriptions: Subscription[] = [];

  selectedSubTenant: app.models.WorkspaceModel;
  subTenants: app.models.WorkspaceModel[];

  USER_NAV_ACTIONS = USER_NAV_ACTIONS;
  windowSizeLgUp: boolean;

  public constructor(
    private _ngbModal: NgbModal,
    private _router: Router,
    private _globalService: GlobalService,
    private _notificationAPIService: NotificationAPIService,
    private _ngbOffcanvas: NgbOffcanvas,
    private _windowEventService: WindowEventsService,
    private _startupService: StartupService
  ) {}

  public ngOnInit() {
    this.windowSizeLgUp = window.innerWidth >= RESPONSIVE_BREAKPOINTS.lg;
    let subscription = this._windowEventService.onResize.subscribe(() => {
      this.windowSizeLgUp = window.innerWidth >= RESPONSIVE_BREAKPOINTS.lg;
      this.windowSizeLgUp && this.ngbOffcanvas?.close();
    });
    this.subscriptions.push(subscription);

    if (this.hasUserRights) {
      this._notificationAPIService.getNotifications().subscribe(result => {
        this._globalService.numberOfNotifications = result.filter(x => !x.isRead).length;
      });
    }

    subscription = this._globalService.obsNumberOfNotifications.subscribe(numberOfNotifications => {
      this.numberOfNotifications = numberOfNotifications;
    });
    this.subscriptions.push(subscription);

    this.subTenants = this._globalService.subTenants;
    this.selectedSubTenant = this._globalService.subTenant;
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  public closeNotificationsPopOver() {
    this.notificationsPopOver.close();
  }

  public openMobileNav(ngbOffcanvasTemplate: TemplateRef<any>) {
    this.ngbOffcanvas = this._ngbOffcanvas.open(ngbOffcanvasTemplate, {
      panelClass: 'mobile-nav-offcanvas',
      position: 'end',
      backdrop: 'static',
    });
    this.ngbOffcanvas.closed.subscribe(closeResult => {
      this.ngbOffcanvasClosedResult = closeResult;
    });

    this.ngbOffcanvas.hidden.subscribe(() => {
      this.ngbOffcanvasClosedResult &&
        setTimeout(() => {
          this.userNavOptionSelect.emit(this.ngbOffcanvasClosedResult);
        }, 0);
    });
  }

  onUserNavOptionSelect(option: string, isMobileMenuOption: boolean = true) {
    if (isMobileMenuOption) {
      this.ngbOffcanvas.close(option);
    } else {
      this.userNavOptionSelect.emit(option);
    }
  }

  subTenantSelectHandler(subTenant: app.models.WorkspaceModel) {
    if (subTenant) {
      const modal = this._ngbModal.open(PopupComponent, { backdrop: 'static' });
      modal.componentInstance.title = 'common.defaultModal.infoTitle';
      modal.componentInstance.description = 'tenant.modal.doYouContinue';
      modal.result.then(result => {
        if (result) {
          this._globalService.subTenant = subTenant;
          this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this._router.navigate([ROUTES.DEFAULT_ROUTE_URL]);
          });
        } else {
          this.selectedSubTenant = { ...this.subTenants.find(x => x.id == this._globalService.subTenant.id) };
        }
      });
    } else {
      this.selectedSubTenant = { ...this.subTenants.find(x => x.id == this._globalService.subTenant.id) };
    }
  }
}
